import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType } from 't4core';
import * as uuid from 'uuid';

@Component({
    selector: 'AddCostsDialog',
    templateUrl: 'AddCostsDialog.html',
    styleUrls: ['./AddCostsDialog.css']
})
export class AddCostsDialog extends DialogBase {

    @ViewChild("txtcontactFirstName", { static: false }) public txtcontactFirstName: NgModel;
    @ViewChild("txtcontactLastName", { static: false }) public txtcontactLastName: NgModel;
    @ViewChild("txtcontactEmail", { static: false }) public txtcontactEmail: NgModel;
    @ViewChild("txtcontactPhone", { static: false }) public txtcontactPhone: NgModel;

    constructor(
        public dialogRef: MatDialogRef<AddCostsDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("AddCostsDialog");

    }

    public async ngOnInit() {
        this.loading = true;
        this.loading = false;
    }

    public save() {
        this.dialogRef.close(this.data);
    }
}
